/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  Overrides,
  BigNumberish,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Bridge, BridgeInterface } from "../Bridge";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint8",
        name: "domainID",
        type: "uint8",
      },
      {
        internalType: "address",
        name: "accessControl",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "bytes4",
        name: "funcSig",
        type: "bytes4",
      },
    ],
    name: "AccessNotAllowed",
    type: "error",
  },
  {
    inputs: [],
    name: "DepositToCurrentDomain",
    type: "error",
  },
  {
    inputs: [],
    name: "EmptyProposalsArray",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidProposalSigner",
    type: "error",
  },
  {
    inputs: [],
    name: "MPCAddressAlreadySet",
    type: "error",
  },
  {
    inputs: [],
    name: "MPCAddressIsNotUpdatable",
    type: "error",
  },
  {
    inputs: [],
    name: "MPCAddressNotSet",
    type: "error",
  },
  {
    inputs: [],
    name: "MPCAddressZeroAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "NonceDecrementsNotAllowed",
    type: "error",
  },
  {
    inputs: [],
    name: "ResourceIDNotMappedToHandler",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "newAccessControl",
        type: "address",
      },
    ],
    name: "AccessControlChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "destinationDomainID",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "depositNonce",
        type: "uint64",
      },
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "handlerResponse",
        type: "bytes",
      },
    ],
    name: "Deposit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [],
    name: "EndKeygen",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes",
        name: "lowLevelData",
        type: "bytes",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "originDomainID",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "depositNonce",
        type: "uint64",
      },
    ],
    name: "FailedHandlerExecution",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "newFeeHandler",
        type: "address",
      },
    ],
    name: "FeeHandlerChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "hash",
        type: "string",
      },
    ],
    name: "KeyRefresh",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "originDomainID",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "depositNonce",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "dataHash",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "handlerResponse",
        type: "bytes",
      },
    ],
    name: "ProposalExecution",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "txHash",
        type: "string",
      },
    ],
    name: "Retry",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [],
    name: "StartKeygen",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [],
    name: "_MPCAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "_accessControl",
    outputs: [
      {
        internalType: "contract IAccessControlSegregator",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    name: "_depositCounts",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "_domainID",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "_feeHandler",
    outputs: [
      {
        internalType: "contract IFeeHandler",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "_resourceIDToHandlerAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "isValidForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "usedNonces",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "adminPauseTransfers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "adminUnpauseTransfers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "handlerAddress",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "args",
        type: "bytes",
      },
    ],
    name: "adminSetResource",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "handlerAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
    ],
    name: "adminSetBurnable",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "domainID",
        type: "uint8",
      },
      {
        internalType: "uint64",
        name: "nonce",
        type: "uint64",
      },
    ],
    name: "adminSetDepositNonce",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
      {
        internalType: "bool",
        name: "valid",
        type: "bool",
      },
    ],
    name: "adminSetForwarder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAccessControl",
        type: "address",
      },
    ],
    name: "adminChangeAccessControl",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newFeeHandler",
        type: "address",
      },
    ],
    name: "adminChangeFeeHandler",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "handlerAddress",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "adminWithdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "destinationDomainID",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "resourceID",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "depositData",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "feeData",
        type: "bytes",
      },
    ],
    name: "deposit",
    outputs: [
      {
        internalType: "uint64",
        name: "depositNonce",
        type: "uint64",
      },
      {
        internalType: "bytes",
        name: "handlerResponse",
        type: "bytes",
      },
    ],
    stateMutability: "payable",
    type: "function",
    payable: true,
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint8",
            name: "originDomainID",
            type: "uint8",
          },
          {
            internalType: "uint64",
            name: "depositNonce",
            type: "uint64",
          },
          {
            internalType: "bytes32",
            name: "resourceID",
            type: "bytes32",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct Bridge.Proposal",
        name: "proposal",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "executeProposal",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint8",
            name: "originDomainID",
            type: "uint8",
          },
          {
            internalType: "uint64",
            name: "depositNonce",
            type: "uint64",
          },
          {
            internalType: "bytes32",
            name: "resourceID",
            type: "bytes32",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct Bridge.Proposal[]",
        name: "proposals",
        type: "tuple[]",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "executeProposals",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "startKeygen",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "MPCAddress",
        type: "address",
      },
    ],
    name: "endKeygen",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "hash",
        type: "string",
      },
    ],
    name: "refreshKey",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "txHash",
        type: "string",
      },
    ],
    name: "retry",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "domainID",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "depositNonce",
        type: "uint256",
      },
    ],
    name: "isProposalExecuted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint8",
            name: "originDomainID",
            type: "uint8",
          },
          {
            internalType: "uint64",
            name: "depositNonce",
            type: "uint64",
          },
          {
            internalType: "bytes32",
            name: "resourceID",
            type: "bytes32",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct Bridge.Proposal[]",
        name: "proposals",
        type: "tuple[]",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "verify",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
];

const _bytecode =
  "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";

type BridgeConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: BridgeConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Bridge__factory extends ContractFactory {
  constructor(...args: BridgeConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "Bridge";
  }

  deploy(
    domainID: BigNumberish,
    accessControl: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Bridge> {
    return super.deploy(
      domainID,
      accessControl,
      overrides || {}
    ) as Promise<Bridge>;
  }
  getDeployTransaction(
    domainID: BigNumberish,
    accessControl: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(domainID, accessControl, overrides || {});
  }
  attach(address: string): Bridge {
    return super.attach(address) as Bridge;
  }
  connect(signer: Signer): Bridge__factory {
    return super.connect(signer) as Bridge__factory;
  }
  static readonly contractName: "Bridge";
  public readonly contractName: "Bridge";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BridgeInterface {
    return new utils.Interface(_abi) as BridgeInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Bridge {
    return new Contract(address, _abi, signerOrProvider) as Bridge;
  }
}
